module.exports = __webpack_public_path__ + "media/images/homes/Abettercheckoutexperience-f16ab02b6c42232bee249bddc6407c75.png";